import { ALL_BODY_SHAPES, ALL_BODY_TYPES } from 'containers/feed/constant';
import { store } from 'redux/store';
import utils from './utils';
import { Store } from '../containers/my_sessions/types';
import trimEnd from 'lodash/trimEnd';

interface IFilterList {
    title: string;
    value: string;
    isActive: boolean;
    isShow: boolean;
}
export interface IFilterProps {
    firstLoadRef?: any;
    isSearch?: boolean;
    gender?: string;
    stylistName?: string;
    currentMinPrice?: number;
    currentMaxPrice?: number;
    genderFilterList?: any;
    styleMaxPrice?: number;
    styleMinPrice?: number;
    categoryFilterList?: any;
    bodyShapeFilterList?: any;
    bodyTypeFilterList?: any;
    purposeDefault?: any;
    listCategoriesDefault?: any;
    bodyShapeDefault?: any;
    bodyTypeDefault?: any;
    personaDefault?: IFilterList[];
    filterStrDefault: string;
    isRecommended?: boolean;
    brandFilterList?: any;
}
export const buildFilter = ({
    firstLoadRef,
    isSearch,
    gender,
    stylistName,
    currentMinPrice,
    currentMaxPrice,
    genderFilterList,
    categoryFilterList,
    listCategoriesDefault,
    bodyShapeFilterList,
    bodyShapeDefault,
    bodyTypeFilterList,
    bodyTypeDefault,
    purposeDefault,
    filterStrDefault,
    personaDefault,
    isRecommended,
    brandFilterList,
}: IFilterProps) => {
    let filterStr = filterStrDefault;

    if (stylistName) {
        filterStr = `${filterStr} AND user.firstName:"${stylistName}"`;
    }
    if (utils.isAppInWidgetMode()) {
        const globalState = store.getState();
        const widgetStore = globalState?.widget?.store;
        if (widgetStore) {
            filterStr += ` AND (${buildStoreFilter(widgetStore)})`;
        }
    }
    if (isSearch) {
        if (currentMaxPrice || currentMinPrice) {
            filterStr += ` AND (price=0 OR `;
            if (!currentMaxPrice) {
                filterStr += `price >= ${currentMinPrice})`;
            } else if (!currentMinPrice) {
                filterStr += `price <= ${currentMaxPrice})`;
            } else {
                filterStr += `price:${currentMinPrice} TO ${currentMaxPrice})`;
            }
        }
        if (purposeDefault) {
            filterStr += ` AND purposes.title:"${purposeDefault.value}"`;
        }
        const activeGender = genderFilterList.filter((item) => item.isActive);
        if (activeGender && activeGender.length) {
            if (activeGender.length === 1) {
                filterStr += ` AND genders.value:"${activeGender[0].value}"`;
            } else {
                const genderCondition = activeGender.reduce((condition, item) => {
                    const operator = condition === '' ? '' : ' OR ';
                    return condition + operator + `genders.value:"${item.value}"`;
                }, '');
                filterStr += ` AND (${genderCondition})`;
            }
        } else if (firstLoadRef.current) {
            filterStr = `${filterStr} AND genders.value:"${gender}"`;
        }
        if (firstLoadRef.current && listCategoriesDefault.length) {
            if (listCategoriesDefault.length === 1) {
                filterStr += ` AND categories.name:"${listCategoriesDefault[0].value}"`;
            } else {
                const categoryCondition = listCategoriesDefault.reduce((condition, item) => {
                    const operator = condition === '' ? '' : ' OR ';
                    return condition + operator + `categories.name:"${item.value}"`;
                }, '');
                filterStr += ` AND (${categoryCondition})`;
            }
        }
        if (categoryFilterList.length) {
            const activeCategory = categoryFilterList.filter((item) => item.isActive);
            if (activeCategory && activeCategory.length) {
                if (activeCategory.length === 1) {
                    filterStr += ` AND categories.name:"${activeCategory[0].value}"`;
                } else {
                    const categoryCondition = activeCategory.reduce((condition, item) => {
                        const operator = condition === '' ? '' : ' OR ';
                        return condition + operator + `categories.name:"${item.value}"`;
                    }, '');
                    filterStr += ` AND (${categoryCondition})`;
                }
            }
        }

        const bodyShapeFilterListApplies = [...bodyShapeFilterList];
        if (firstLoadRef.current && bodyShapeDefault?.length) {
            const bodyShapeDefaultExist = bodyShapeFilterListApplies.find(
                (item) => item?.value?.toLowerCase() === bodyShapeDefault[0]?.value?.toLowerCase(),
            );
            if (!bodyShapeDefaultExist) bodyShapeFilterListApplies.push(bodyShapeDefault[0]);
        }
        const activeBodyShape = bodyShapeFilterListApplies.filter((item) => item?.isActive);
        if (activeBodyShape && activeBodyShape.length) {
            const activeShapes = [...activeBodyShape, { value: ALL_BODY_SHAPES }];
            const bodyShapeCondition = activeShapes.reduce((condition, item) => {
                const operator = condition === '' ? '' : ' OR ';
                return condition + operator + `bodyShapes.title:"${item.value}"`;
            }, '');
            filterStr += ` AND (${bodyShapeCondition})`;
        }
        if (brandFilterList?.length) {
            const brandFilterListApplies = [...brandFilterList];
            const activeBrand = brandFilterListApplies?.filter((item) => item?.isActive);
            if (activeBrand && activeBrand?.length) {
                const activeBrands = [...activeBrand];
                const brandsCondition = activeBrands?.reduce((condition, item) => {
                    const operator = condition === '' ? '' : ' OR ';
                    return condition + operator + `items.data.brand.name :"${item.value}"`;
                }, '');
                filterStr += ` AND (${brandsCondition})`;
            }
        }

        const bodyTypeFilterListApplies = [...bodyTypeFilterList];
        if (firstLoadRef.current && bodyTypeDefault?.length) {
            const bodyTypeDefaultExist = bodyTypeFilterListApplies.find(
                (item) => item?.value?.toLowerCase() === bodyTypeDefault[0]?.value?.toLowerCase(),
            );
            if (!bodyTypeDefaultExist) bodyTypeFilterListApplies.push(bodyTypeDefault[0]);
        }
        const activeBodyType = bodyTypeFilterListApplies.filter((item) => item?.isActive);
        if (activeBodyType && activeBodyType.length) {
            const activeTypes = [...activeBodyType, { value: ALL_BODY_TYPES }];
            const bodyTypeCondition = activeTypes.reduce((condition, item) => {
                const operator = condition === '' ? '' : ' OR ';
                return condition + operator + `bodyTypes.title:"${item.value}"`;
            }, '');
            filterStr += ` AND (${bodyTypeCondition})`;
        }
    } else {
        if (gender) {
            filterStr = `${filterStr} AND genders.value:"${gender}"`;
        }
        if (isRecommended) {
            if (categoryFilterList.length) {
                const activeCategory = categoryFilterList.filter((item) => item.isActive);
                if (activeCategory && activeCategory.length) {
                    if (activeCategory.length === 1) {
                        filterStr += ` AND categories.name:"${activeCategory[0].value}"`;
                    } else {
                        const categoryCondition = activeCategory.reduce((condition, item) => {
                            const operator = condition === '' ? '' : ' OR ';
                            return condition + operator + `categories.name:"${item.value}"`;
                        }, '');
                        filterStr += ` AND (${categoryCondition})`;
                    }
                }
            }
            if (brandFilterList?.length) {
                const activeBrand = brandFilterList.filter((item) => item.isActive);
                if (activeBrand && activeBrand.length) {
                    if (activeBrand.length === 1) {
                        filterStr += ` AND items.data.brand.name:"${activeBrand[0].value}"`;
                    } else {
                        const brandCondition = activeBrand.reduce((condition, item) => {
                            const operator = condition === '' ? '' : ' OR ';
                            return condition + operator + `items.data.brand.name:"${item.value}"`;
                        }, '');
                        filterStr += ` AND (${brandCondition})`;
                    }
                }
            }
            if (bodyShapeDefault.length) {
                filterStr += ` AND (bodyShapes.title:"${bodyShapeDefault[0].value}" OR bodyShapes.title:"${ALL_BODY_SHAPES}")`;
            }
            if (bodyTypeDefault.length) {
                filterStr += ` AND (bodyTypes.title:"${bodyTypeDefault[0].value}" OR bodyTypes.title:"${ALL_BODY_TYPES}")`;
            }
            if (personaDefault && personaDefault.length) {
                const activePersona = personaDefault.filter((item) => item.isActive);
                if (activePersona && activePersona.length) {
                    if (activePersona.length === 1) {
                        filterStr += ` AND personas.title:"${activePersona[0].value}"`;
                    } else {
                        const personaCondition = activePersona.reduce((condition, item) => {
                            const operator = condition === '' ? '' : ' OR ';
                            return condition + operator + `personas.title:"${item.value}"`;
                        }, '');
                        filterStr += ` AND (${personaCondition})`;
                    }
                }
            }
        }
    }
    return filterStr;
};

export const buildStoreFilter = (store: Store) => {
    const { url, filterConfigResponse: filterConfig } = store;
    let filter = '';
    if (filterConfig) {
        try {
            const storeDomain = new URL(url).origin;
            filter = `items.data.productDomain:"${storeDomain}"`;
            if (filterConfig.disallowedStores?.length) {
                const disallowedCondition = filterConfig.disallowedStores.map(
                    (domain: string) => `NOT items.data.productDomain:"${trimEnd(domain, '/')}"`,
                );
                filter += ' AND ' + disallowedCondition.join(' AND ');
            }
        } catch (e) {
            console.error('BUILD STORE FILTER ERROR', e);
        }
    } else {
        filter = `items.data.storeId: ${store?.id}`;
    }

    return filter;
};

export const constructItemUrls = (urls: string[], sourceUrl: string, affiliateLink: string) => {
    const baseUrlObject = new URL(sourceUrl);
    let itemUrlForFilter = '';
    let itemUrls: string[] = [];
    urls.forEach((item) => {
        const itemUrl = baseUrlObject.origin + item;
        let itemUrlwithAffiliateCode = new URL(itemUrl);
        if (affiliateLink) {
            new URL(affiliateLink).searchParams.forEach((key, val) => {
                itemUrlwithAffiliateCode.searchParams.append(val, key);
            });
        }
        itemUrlForFilter =
            itemUrlForFilter +
            `${itemUrlForFilter && ' OR'} items.data.url: "${itemUrl}"${
                itemUrlwithAffiliateCode && ' OR'
            } items.data.url: "${itemUrlwithAffiliateCode}"`;
        itemUrls.push(itemUrl);
    });
    return { itemUrlForFilter, itemUrls };
};

export const generateItemUrlWithAffiliateCode = (url: string, affiliateLink: string) => {
    try {
        let itemUrlWithAffiliateCode = new URL(url);
        if (affiliateLink) {
            new URL(affiliateLink).searchParams.forEach((key, val) => {
                itemUrlWithAffiliateCode.searchParams.append(val, key);
            });
        }
        return itemUrlWithAffiliateCode.href;
    } catch (e) {
        return null;
    }
};
